import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@environments/environment';

@Injectable()
export class AllowOriginInterceptor implements HttpInterceptor {
    constructor() { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if(request.url.includes(environment.baseApiUrl)) {
            request = request.clone({
                setHeaders: {
                    'Access-Control-Allow-Origin': environment.rootRoute
                }
            });
        }
        
        return next.handle(request);
    }
}